import React from 'react';
import classnames from 'classnames';
import styles from './textarea.scss';

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement>

function Textarea({
  className = '',
  ...rest
}: Props, ref: React.Ref<HTMLTextAreaElement>) {
  return (
    <textarea
      ref={ref}
      className={classnames(styles.textarea, className)}
      {...rest} />
  );
}

export default React.forwardRef<HTMLTextAreaElement, Props>(Textarea);
